import type { ServiceConfigFactory } from '../../types'

export default (({ viewerHandlers }) => {
	return {
		promptLogin: viewerHandlers.siteMembersService.promptLogin,
		logout: viewerHandlers.siteMembersService.logout,
	}
}) as ServiceConfigFactory
